import React, { useEffect, useState } from "react";
import "./Header.css";
import { NavLink } from "react-router-dom";

const SHOW_ORDER = false;

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(v => !v);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header className="navbar">
      <div className="navbar-left">
        <NavLink to="/" className="brand" onClick={closeMenu}>
          <div className="header-logo-drop-left">
            <img
              src="/assets/logo.webp"
              alt="Ruga's Cafe logo"
              className="header-logo"
            />
          </div>
          <span className="brand-name">Ruga's Cafe</span>
        </NavLink>
      </div>

      <nav className={`navbar-links ${menuOpen ? "open" : ""}`}>
        <NavLink to="/" onClick={closeMenu}>Home</NavLink>
        <NavLink to="/menu" onClick={closeMenu}>Menu</NavLink>

        {SHOW_ORDER && (
          <NavLink to="/rugas-app" onClick={closeMenu}>Order</NavLink>
        )}

        <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
      </nav>

      <button
        className="hamburger"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </button>
    </header>
  );
}
